import { KeyResultStatus, ObjectiveStatus } from "@/types";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import { STATUS_CONFIG } from "@/components/okr/okrConstants";

interface OkrStatusBadgeProps {
    status: ObjectiveStatus | KeyResultStatus;
    size?: "sm" | "md";
    className?: string;
}

export function OkrStatusBadge({ status, size = "sm", className }: OkrStatusBadgeProps) {
    // Defensive fallback: BE may emit a status string outside the known enum
    // (typo, new status not yet mapped) — fall back to DRAFT styling instead
    // of crashing on `config.icon` being undefined.
    const config = STATUS_CONFIG[status as ObjectiveStatus] ?? STATUS_CONFIG[ObjectiveStatus.DRAFT];
    const Icon = config.icon;

    return (
        <Badge
            className={cn(
                config.className,
                size === "sm" ? "text-[10px] px-1.5 py-0" : "text-xs px-2 py-0.5",
                className,
            )}
        >
            <Icon className="mr-1 h-3 w-3" />
            {config.label}
        </Badge>
    );
}
